import { createContext } from "react";
import type useDepartmentIdentityById from "src/hooks/data/load/useDepartmentIdentityById";

export interface IDepartmentIdentityContext extends ReturnType<
    typeof useDepartmentIdentityById
> {}

export const DepartmentIdentityContext = createContext<IDepartmentIdentityContext>({
    data: undefined,
    error: undefined,
    loading: false,
    validating: false,
    mutate: async () => undefined,
    refresh: async () => undefined,
});

export default DepartmentIdentityContext;
